/**
 * Use this file to define which URL /slugs should route to the supercampaign landing page.
 * Should correspond with eventData/groupFundraisers.ts in microservice
 */

export const supercampaignConfig = ['whyhunger'];
